import { CLIENT_COMMON_ERROR } from '@savgroup-front-common/constants';

import {
  ErrorFromBack,
  getErrorProperty,
} from '../../../../helpers/errorsMessage';

export const isNetworkErrorWhileOffline = (
  error: Error | ErrorFromBack,
): boolean => {
  const isOffline = typeof navigator !== 'undefined' && !navigator.onLine;

  if (!isOffline) {
    return false;
  }

  return getErrorProperty(error) === CLIENT_COMMON_ERROR.FAILED_TO_FETCH;
};
